import { Button, Modal, Typography } from "antd"
import { useTranslation } from "react-i18next"

/**
 * Chrome's and Edge's PDF viewer read these from the URL fragment: no
 * thumbnail sidebar, and the page fitted to the frame's width, so the whole
 * invoice reads at once instead of a cut-off 100%. Other viewers ignore them.
 */
const PDF_VIEW = "#navpanes=0&view=FitH"

export const previewFrameSrc = (url: string) =>
  url.includes("#") ? url : `${url}${PDF_VIEW}`

interface InvoicePreviewModalProps {
  /** A `blob:` URL of the rendered PDF. */
  url: string
  onClose: () => void
}

export function InvoicePreviewModal({
  url,
  onClose
}: InvoicePreviewModalProps) {
  const { t } = useTranslation()

  return (
    <Modal
      open
      title={t("invoices.preview.title")}
      onCancel={onClose}
      width={1200}
      style={{ maxWidth: "95vw" }}
      centered
      footer={
        <Button type="primary" onClick={onClose}>
          {t("invoices.preview.backToEdit")}
        </Button>
      }
    >
      <Typography.Text type="secondary">
        {t("invoices.preview.notSaved")}
      </Typography.Text>
      <iframe
        data-testid="invoice-preview-frame"
        title={t("invoices.preview.title")}
        src={previewFrameSrc(url)}
        className="mt-3 h-[82vh] w-full rounded border border-solid border-[var(--ant-color-border)]"
      />
    </Modal>
  )
}
